"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridConstants = void 0;
/**
 * Grid Constants
 */
class GridConstants {
}
exports.GridConstants = GridConstants;
/**
 * Minimum longitude
 */
GridConstants.MIN_LON = -180.0;
/**
 * Maximum longitude
 */
GridConstants.MAX_LON = 180.0;
/**
 * Minimum latitude
 */
GridConstants.MIN_LAT = -90.0;
/**
 * Maximum latitude
 */
GridConstants.MAX_LAT = 90.0;
/**
 * Omitted band letter 'I'
 */
GridConstants.BAND_LETTER_OMIT_I = 'I';
/**
 * Omitted band letter 'O'
 */
GridConstants.BAND_LETTER_OMIT_O = 'O';
/**
 * Max map zoom level
 */
GridConstants.MAX_MAP_ZOOM_LEVEL = 21;
/**
 * North single character as a string
 */
GridConstants.NORTH_CHAR = 'N';
/**
 * South single character as a string
 */
GridConstants.SOUTH_CHAR = 'S';
/**
 * West single character as a string
 */
GridConstants.WEST_CHAR = 'W';
/**
 * East single character as a string
 */
GridConstants.EAST_CHAR = 'E';
//# sourceMappingURL=GridConstants.js.map